import { render, staticRenderFns } from "./ProjectUserColumn.vue?vue&type=template&id=6cb7b612&scoped=true&"
import script from "./ProjectUserColumn.vue?vue&type=script&lang=js&"
export * from "./ProjectUserColumn.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUserColumn.vue?vue&type=style&index=0&id=6cb7b612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7b612",
  null
  
)

export default component.exports